import styled, { css } from 'styled-components';
import { media } from '@navent-re/global-styled';
import { select } from '@panel/commons/core/themev2';

const BottomFooterContainer = styled.div`
  display: flex;
  background: #ededed;
  padding: 15px 0px;
  margin-top: 0%;
  @media ${media.mobile} {
    padding: 15px 15px 15px 15px;
    height: fit-content;
    margin-top: 0%;
  }
`;

const NewBottomFooterContainer = styled.div`
  display: flex;
  background: #ededed;
  padding: 15px 0px;
  margin-top: 0%;
  flex-direction: column;
  @media ${media.mobile} {
    padding: 15px 15px 15px 15px;
    height: fit-content;
    margin-top: 0%;
  }
`;

const FiscalQRBoxContainer = styled.div`
  display: flex;
  /* @media (max-width: 820px) {
    display: flex;
    margin-right: 4%;
    margin-left: 8%;
  } */
  @media (max-width: 360px) {
    display: flex;
    margin-right: 2%;
    width: 30%;
  }
`;

const FiscalQRBox = styled.a`
  flex-grow: 0;
  margin-right: 8px;
  width: ${({ device }) => (device === 'mobile' ? '47px' : '40px')};
  padding-top: ${({ device }) => (device === 'mobile' ? '0' : '0px')};
  margin-right: 4px;
  > img {
    width: 100%;
    margin-top: 0%;
    @media (max-width: 1440px) {
      ${() =>
        media.tablet &&
        css`
          margin-top: 0%;
        `}
    }
  }
  @media (max-width: 360px) {
    padding-right: 0;
  }
  :nth-child(2) {
    width: ${({ device }) => (device === 'mobile' ? '49px' : '42px')};
  }
  :nth-child(1) {
    padding-top: 1px;
  }
`;

const LegalData = styled.div`
  flex-grow: 1;
  font-size: 14px;
  color: ${select('black')};
  @media (max-width: 1440px) {
    ${() =>
      media.tablet &&
      css`
        width: 70%;
      `}
  }
  @media (min-width: 820px) {
    ${() =>
      media.tablet &&
      css`
        width: 60%;
        margin-left: 8px;
      `}
  }
  @media ${media.mobile} {
    flex: 2;
    width: 74%;
  }
  > p {
    margin: 0 0 0px;
  }
  > a {
    color: ${select('black')};
    text-decoration: none;
    line-height: 0;
    @media ${media.mobile} {
      font-size: 12px;

      line-height: 0;
    }
    &:last-child:after {
      display: none;
    }

    > p {
      margin: 0;
    }
  }
`;

const LegalLinkContainer = styled.div`
  img {
    position: relative;
    top: 5px;
    margin-right: 4px;
  }
  @media (max-width: 820px) {
    ${() =>
      media.tablet &&
      css`
        width: auto;
        height: fit-content;
        display: block;
        white-space: break-spaces;
      `}
  }
  @media ${media.mobile} {
    width: auto;
    height: fit-content;
    display: block;
    white-space: break-spaces;
  }
  @media (min-width: 820px) {
    ${() =>
      media.tablet &&
      css`
        white-space: break-spaces;
        width: 100%;
      `}
  }
`;

const LegalLink = styled.a`
  color: ${select('black')};
  font-size: 14px;
  display: inline-block;
  text-align: left;
  width: auto;
  margin-right: 4px;
  text-decoration: none;
  &:last-child:after {
    display: none;
  }
  &:after {
    content: '-';
    width: 10px;
    height: 10px;
    text-align: center;
    padding: 0 2px 0 4px;
  }
  @media (max-width: 1440px) {
    ${() =>
      media.tablet &&
      css`
        font-size: 13px;
      `}
  }
  @media ${media.mobile} {
    font-size: 12px;
    display: contents;

    font-weight: 500;
  }
`;

const NaventBox = styled.a`
  color: ${select('black')};
  font-size: 14px;
  flex-grow: 0;
  padding-top: 22px;
  margin-left: auto;
  text-decoration: none;
  @media (max-width: 1440px) {
    ${() =>
      media.tablet &&
      css`
        font-size: 13px;
        width: 253.89px;
      `}
  }
  @media (max-width: 820px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        width: 100%;
        display: block;
        text-align: center;
        border-top: 1px solid hsla(0, 0%, 100%, 0.2);
        padding-top: 10px;
        margin-top: 15px;
      `}
  }
  @media ${media.mobile} {
    width: 100%;
    display: block;
    text-align: center;
    border-top: 1px solid hsla(0, 0%, 100%, 0.2);
    padding-top: 10px;
    margin-top: 15px;
  }
`;

const NaventLogo = styled.img`
  vertical-align: middle;
  padding: 0 0 4px 7px;
  @media (max-width: 1440px) {
    ${() =>
      media.tablet &&
      css`
        width: 64.01px;
      `}
  }
`;

const RegretButton = styled.a`
  font-size: 18px;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
  color: black;
  cursor: pointer;
  margin-top: 10px;
`;

const Separator = styled.div`
  width: 1px;
  height: 40px;
  margin: 0 24px;
  background-color: #c8c8c8;
`;

const DefConsumerCotainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 40px;
`;

const SeparatorHorizontal = styled.div`
  width: 100%;
  height: 1px;
  margin: 24px 0;
  background-color: #c8c8c8;
`;

const LogoGQAContainer = styled.div`
  width: 100%;
`;

export {
  LogoGQAContainer,
  SeparatorHorizontal,
  Separator,
  DefConsumerCotainer,
  RegretButton,
  NewBottomFooterContainer,
  BottomFooterContainer,
  FiscalQRBoxContainer,
  FiscalQRBox,
  LegalData,
  NaventBox,
  NaventLogo,
  LegalLinkContainer,
  LegalLink
};
